export default __webpack_public_path__ + "static/media/94.920874c1.jpg";